import {selectDefined} from '@benchling/js-utils';

import pick, {PickObject} from 'util/pick';

/*
  Selects a subset of an object with the desired `keys`, while also limiting the returned key/value pairs to
  non-undefined values.

  Operates like _.pick, but is typesafe and filters out undefined values.

  Example:
  pickDefined({x: undefined, y: 5, z: 3}, 'x', 'z') -> {z: 3}

  Also see:
  - pick
  - selectDefined
*/
export default function pickDefined<T extends PickObject, K extends keyof T>(
  object: T,
  ...keys: Array<K>
): Pick<T, K> {
  const objectWithSelectedKeys = pick(object, ...keys);
  return selectDefined(objectWithSelectedKeys);
}
